import { render, staticRenderFns } from "./AdminFabbricatiIdView.vue?vue&type=template&id=3c7fe4ab&"
import script from "./AdminFabbricatiIdView.vue?vue&type=script&lang=ts&"
export * from "./AdminFabbricatiIdView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports